<template>
    <Popup
            v-model="popup"
            position="bottom"
            style="height:60%;overflow: hidden;"
            @click-overlay="$emit('cancel')"
    >
        <NavBar title="请选择" >
      <span
              v-if="list.length==checked.length"
              style="color:#ff0000"
              @click="()=>{this.checked=[]}"
              slot="left"
      >取消全选</span>
            <span v-else style="color:#ff0000" @click="()=>{this.checked=this.list}" slot="left">全选</span>
            <span style="color:#228EFA" @click="onConfirm" slot="right">确定</span>
        </NavBar>
        <div style="margin-top:0px;" class="panel-field-list">
            <CheckboxGroup v-model="checked">
                <Cell v-for="(item,index) in list" :key="index" @click="check(index)" clickable>
                    <Checkbox ref="myChcekbox" slot="icon" :name="item">
                        <div slot="default" style="margin-left:3px;">
                            <h3>
                                <span style="font-weight:600;color:#000">通道名：{{item.name}}</span>
                                &nbsp;
                                <!-- <span style="color:#1890ff;font-size:13px;">{{item.code}}</span> -->
                                <p style="color:#555;font-size:12px;margin-top:0px;">通道代码：{{item.code}}</p>
                            </h3>
                        </div>
                    </Checkbox>
                </Cell>
            </CheckboxGroup>
        </div>
    </Popup>
</template>
<script>
import { Cell, Checkbox, CheckboxGroup, Icon, NavBar, Popup } from "vant";

export default {
  components: { Popup, Icon, NavBar, Checkbox, CheckboxGroup, Cell },
  mounted() {},
  props: {
    list: { type: Array, required: true },
    show: { type: Boolean, required: true }
  },
  data() {
    return {
      popup: false,
      checked: []
    };
  },
  watch: {
    show(value) {
      this.popup = value;
    }
  },
  methods: {
    check(index) {
      this.$refs.myChcekbox[index].toggle();
    },
    onConfirm() {
      const { checked } = this;
      let codeList = [];
      let nameList = [];
      checked.forEach(item => {
        codeList.push(item.code);
        nameList.push(item.name);
      });
      this.$emit("ok", codeList.join(","), nameList.join(","));
    }
  }
};
</script>
<style lang="less" scoped>
.panel-field-list {
  display: flex;
  flex-direction: column;
  height: ~"calc(100% - 55px)";
  overflow-y: scroll;
}
</style>
